module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    attrs: {
      "listTitle": "Usuários",
      "filterTitle": "Listagem de usuários",
      "loading": _vm.usersFetching,
      "total": _vm.usersTotal,
      "typesListAvailable": ['displayList'],
      "sortDefault": {
        field: 'email',
        order: 'asc'
      },
      "sortFields": ['email']
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "hint hint--left btn btn--info",
    attrs: {
      "slot": "header-actions",
      "data-label": "Vincular usuário"
    },
    on: {
      "click": function($event) {
        _vm.linkItemFlag = true
      }
    },
    slot: "header-actions"
  }, [_c('i', {
    staticClass: "icon-plus icon-download2"
  })]), _vm._v(" "), _c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Email"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.email),
      expression: "options.email"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "email", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return (_vm.users.length) ? _c('div', {
      key: user,
      staticClass: "l-col-12@md"
    }, [_c('user-card', {
      attrs: {
        "user": user,
        "hasAdminAccess": _vm.hasAdminAccess
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (!_vm.users.length) ? _c('div', {
    staticClass: "l-col u-textCenter"
  }, [_c('panel', [_vm._v("\n      Nenhum usuário encontrado.\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('modal-unlink', {
    on: {
      "option": function($event) {
        return _vm.unlink(_vm.unlinkItem)
      }
    },
    model: {
      value: (_vm.unlinkItemFlag),
      callback: function($$v) {
        _vm.unlinkItemFlag = $$v
      },
      expression: "unlinkItemFlag"
    }
  }), _vm._v(" "), _c('modal-user-roles', {
    attrs: {
      "user": _vm.selectedUser
    },
    on: {
      "saveUserRoles": _vm.saveUserRoles
    },
    model: {
      value: (_vm.userRolesFlag),
      callback: function($$v) {
        _vm.userRolesFlag = $$v
      },
      expression: "userRolesFlag"
    }
  }), _vm._v(" "), _c('modal-link-user', {
    on: {
      "search": _vm.searchUsers
    },
    model: {
      value: (_vm.linkItemFlag),
      callback: function($$v) {
        _vm.linkItemFlag = $$v
      },
      expression: "linkItemFlag"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95270774","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/List/Base.vue
// module id = 3369
// module chunks = 0